/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


 (function(){
     
   
   /* Blog overview */
   $('.ArticleList').masonry({
     // options
     itemSelector: '.OLD_Grid__Cell'
   });  
   
   /* Product -> Size -> Disable sold out variations */
   	$(".ProductForm__Variants .ProductForm__Option.ProductForm__Option--labelled input").each(function(index) {
		if($(".ProductForm__Variants .ProductForm__Option.no-js option").eq(index).is(':disabled'))
			$(this).parent().addClass('disabled');
	});
           
   
   //Remove currency
   localStorage.removeItem('currency');
   
   //Currency to redirect
   $(".CurrencySelector__Select").change(function() {
     
     localStorage.removeItem('currency');
     
     if($('body').hasClass('theme-second_female'))
       var domain = 'secondfemale';
     else
       var domain = 'justfemale';
     
     
     if($(this).val() == 'DKK') {
     	window.location.href = "https://" + domain + ".dk";
     } else if($(this).val() == 'EUR') {
     	window.location.href = "https://" + domain + ".com";
     } else if($(this).val() == 'GBP') {
     	window.location.href = "https://" + domain + ".co.uk";
     } else if($(this).val() == 'SEK') {
     	window.location.href = "https://" + domain + ".se";
     } else if($(this).val() == 'NOK') {
     	window.location.href = "https://" + domain + ".no";
     }
   });
   
   //Open links in new window
   var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && !links[i].hostname.includes("claimlane")) {
        links[i].target = '_blank';
    }
  }
   
   //Filters - custom order for size
   var sizeContainers = [jQuery('.Drawer.CollectionFilters [data-tag^="size_"]').first().parent().parent(), jQuery('.CollectionInner__Sidebar .CollectionFilters [data-tag^="size_"]').first().parent().parent()]

  for(var containerI = 0; containerI < sizeContainers.length; containerI++) {

      var sizeContainer = sizeContainers[containerI]; //jQuery('.CollectionInner__Sidebar .CollectionFilters [data-tag^="size_"]').first().parent().parent();

      var newSizeContainer = jQuery('<ul></ul>');

      var sizeOrder = ['XS', 'S', 'M', 'L', 'XL'];
      for(var i = 0; i < sizeOrder.length; i++) {

          sizeContainer.find('li').each(function() {

              if(sizeOrder[i] == jQuery(this).find('button').first().text()) {

                  newSizeContainer.append(jQuery(this));

                  jQuery(this).parent().remove();
              }

          });

      }

      sizeContainer.prepend(newSizeContainer.html());

  }
   /* POPUP */
   window.popup_change_url_interval = setInterval(function() {
     if(jQuery('.geo-link').length > 0) {
       var popupLink = jQuery('.geo-link').first();
       
       var popupURL = popupLink.attr('href');
       
       if(popupURL[popupURL.length -1] == '/') {
       	popupURL = popupURL.substr(0,popupURL.length -1);
       }
       
       popupURL = popupURL + window.location.pathname;
       
       popupLink.attr('href', popupURL);
       
     	clearInterval(window.popup_change_url_interval);
     }
     
   		
   }, 500);

   
   /* PDP - Product info scroll sticky */
   //If this is on the product page
   if((document.querySelector("body").classList.contains("theme-oval_square") || document.querySelector("body").classList.contains("theme-second_female")) && document.querySelector("body").classList.contains("template-product")) {
    //On load
    moveProductInfo(window.scrollY, true);
    controlProductInfoSticky();
    setTimeout(() => {
      controlProductInfoSticky();
    }, 300)
     
    addEventListener('scroll', (event) => {      
      controlProductInfoSticky();
    });

    addEventListener('resize', (event) => {
      moveProductInfo(event.target.scrollY, true);
    });     
   }

   function moveProductInfo(scrollY, isResize = false) {
    let windowWidth = window.innerWidth;

    let imagesContainer = document.querySelector("#images_container");

    let productInfoWrapper = document.querySelector(".Product__InfoWrapper");

    let productInfoContainer = document.querySelector(".Product__InfoWrapper .Product__Info .Container");

    let stickyContainer = document.querySelector(".Product__Info .sticky_container");

    let productDescription = document.querySelector(".ProductMeta__Description");

    if(isResize) {
      let lastImage = document.querySelector("#images_container .Product__SlideItem:last-of-type");
      if (productDescription) {
        if(windowWidth > 1008) {
          productDescription.style.minHeight = lastImage.clientHeight - 50 + 'px';
        } else {
          productDescription.style.minHeight = '';
        }
      }
      
      stickyContainer.style.position = 'static';
      stickyContainer.style.width = '';
      stickyContainer.style.left = '';
      stickyContainer.style.top = '';
      stickyContainer.style.bottom = '';
      let stickyContainerViewportOffset = stickyContainer.getBoundingClientRect();
      stickyContainer.setAttribute('data-top-distance', stickyContainerViewportOffset.bottom);

      setTimeout(() => {
        let amountOfImages = imagesContainer.getAttribute("data-images");
        let isTwoImagesOrLess = amountOfImages == 0 || amountOfImages == 1 || amountOfImages == 2;
        
        //Only if the images are taller than the info, should we see the fixed info
        if (imagesContainer.clientHeight >= productInfoWrapper.clientHeight && !isTwoImagesOrLess) {
          stickyContainer.style.position = '';

          stickyContainer.style.width = windowWidth < 1008 ? '' : productInfoContainer.clientWidth + 'px';

          let productInfoContainerViewportOffset = productInfoContainer.getBoundingClientRect();

          stickyContainer.style.left = productInfoContainerViewportOffset.left + 'px';
          stickyContainer.style.top = (productInfoContainerViewportOffset.top + window.scrollY) + 'px';
          
          stickyContainer.setAttribute('data-left-fixed', productInfoContainerViewportOffset.left);
          stickyContainer.setAttribute('data-top-fixed', productInfoContainerViewportOffset.top + window.scrollY);
        }
      }, 100)
    }

    if(windowWidth < 1008) {
      return;
    }
     
    let maxTopPosition = productDescription ? productDescription.offsetTop - stickyContainer.clientHeight : imagesContainer.clientHeight - stickyContainer.clientHeight;

    let position = maxTopPosition > scrollY ? scrollY : maxTopPosition;

    stickyContainer.style.top = position + 'px';
   }

  function controlProductInfoSticky() {
    let r = document.querySelector(':root');

    let lastImage = document.querySelector("#images_container .Product__SlideItem:last-of-type");
    let lastImageViewportOffset = lastImage.getBoundingClientRect();

    let productInfoWrapper = document.querySelector(".Product__InfoWrapper");
      
    let productInfoContainer = document.querySelector(".Product__InfoWrapper .Product__Info .Container");
      
    let productInfoMeta = document.querySelector(".Product__InfoWrapper .Product__Info .Container .ProductMeta__Description");
    let productInfoMetaViewportOffset = productInfoMeta ? productInfoMeta.getBoundingClientRect() : lastImageViewportOffset;
    
    let stickyContainer = document.querySelector(".Product__Info .sticky_container");
    let stickyContainerViewportOffset = stickyContainer.getBoundingClientRect();

    let announcementBar = document.querySelector("#shopify-section-announcement");
    let header = document.querySelector("#shopify-section-header");
    let headerViewportOffset = header.getBoundingClientRect();
    
    let windowTop = announcementBar ? (announcementBar.offsetHeight + header.offsetHeight) : header.offsetHeight;
    let windowBottom = window.innerHeight;

    let position = getComputedStyle(stickyContainer).position;

    let lastScrollY = getComputedStyle(r).getPropertyValue('--scrolled-Y') ? parseInt(getComputedStyle(r).getPropertyValue('--scrolled-Y')) : 0;
    let scrollY = window.scrollY;
    let scrollDirection = scrollY >= lastScrollY ? 'down' : 'up';

    function isStickyBottomInsideViewport() {
      const rect = stickyContainer.getBoundingClientRect();
      return Math.floor(rect.bottom) <= window.innerHeight;
    }
    
    function isStickyTopInsideViewport() {
      const rect = stickyContainer.getBoundingClientRect();
      //return Math.floor(rect.top) >= windowTop || (Math.floor(rect.top) - windowTop) <= 1;
      return Math.floor(rect.top + 1) >= windowTop;
    }

    if (position == 'absolute') {
      let lastImagePositionTop = lastImageViewportOffset.top;
      let lastImagePositionBottom = lastImageViewportOffset.bottom;
      let productInfoMetaPositionTop = productInfoMetaViewportOffset.top;
  
      let maxTopPosition = lastImagePositionTop < productInfoMetaPositionTop || !productInfoMeta ? (productInfoMeta ? lastImagePositionTop : lastImagePositionBottom) : productInfoMetaPositionTop;

      maxTopPosition = maxTopPosition - header.offsetHeight;

      if (announcementBar) {
        maxTopPosition = maxTopPosition - announcementBar.offsetHeight;
      }
      
      if(scrollDirection === 'down' && !isStickyBottomInsideViewport() && window.innerHeight < stickyContainerViewportOffset.bottom) { //If scrolling down when the bottom of the content is not visible, and the bottom of the content is below the screen
        //console.log("DOING NOTHING");
        //Do nothing

      } else if(scrollDirection === 'down' && isStickyBottomInsideViewport() && !isStickyTopInsideViewport() && stickyContainer.style.bottom == '') { //When scrolling down, and the bottom is inside the viewport, but the top is not, then set the bottom to be fixed
        //console.log("SETTING 4", window.innerHeight - stickyContainerViewportOffset.bottom);
        
        stickyContainer.style.position = '';
        stickyContainer.style.left = stickyContainer.getAttribute('data-left-fixed') + 'px';
        stickyContainer.style.top = '';
        stickyContainer.style.bottom = (window.innerHeight - stickyContainerViewportOffset.bottom) + 'px';

      } else if(maxTopPosition > stickyContainer.clientHeight && isStickyTopInsideViewport()) { //If the sticky container should reset to the regular fixed position
        //console.log("SETTING 5");

        let positionDiff = stickyContainerViewportOffset.top - Number(stickyContainer.getAttribute('data-top-fixed'));

        stickyContainer.style.position = '';
        stickyContainer.style.left = stickyContainer.getAttribute('data-left-fixed') + 'px';
        //stickyContainer.style.top = stickyContainer.getAttribute('data-top-fixed') + 'px';
        stickyContainer.style.top = (positionDiff > 20 ? stickyContainer.getAttribute('data-top-fixed') : stickyContainerViewportOffset.top) + 'px';
        stickyContainer.style.bottom = '';
      }
      
    } else if(position == 'fixed') {
      let lastImagePositionTop = lastImageViewportOffset.top + window.scrollY;
      let lastImagePositionBottom = lastImageViewportOffset.bottom + window.scrollY;
      let productInfoMetaPositionTop = productInfoMetaViewportOffset.top + window.scrollY;

      let maxTopPosition = lastImagePositionTop < productInfoMetaPositionTop || !productInfoMeta ? (productInfoMeta ? lastImagePositionTop : lastImagePositionBottom) : productInfoMetaPositionTop;
      let maxElement = lastImagePositionTop < productInfoMetaPositionTop || !productInfoMeta ? lastImage : productInfoMeta;
  
      if(scrollDirection === 'down' && !isStickyBottomInsideViewport()) { //When scrolling down and the content is too long for the screen, and the bottom is not visible
        //console.log("SETTING 1")
        let distanceToTop = stickyContainerViewportOffset.top - headerViewportOffset.bottom + window.scrollY;

        stickyContainer.style.position = 'absolute';
        stickyContainer.style.left = 0;
        stickyContainer.style.top = Math.round(distanceToTop) + 'px';
        stickyContainer.style.bottom = '';

      } else if(scrollDirection === 'up' && !isStickyTopInsideViewport()) { //When scrolling up and the top of the content is not visible
        //console.log("SETTING 2")

        stickyContainer.style.position = 'absolute';
        stickyContainer.style.left = 0;
        stickyContainer.style.top = (window.scrollY - (stickyContainer.offsetHeight - (window.innerHeight - windowTop))) + 'px';
        stickyContainer.style.bottom = '';

      } else if(maxTopPosition <= stickyContainerViewportOffset.bottom + window.scrollY) { //If scrolled past the bottom of where the sticky content should go, make it stay at that point
        //console.log("SETTING 3");
        stickyContainer.style.position = 'absolute';
        stickyContainer.style.left = 0;
        stickyContainer.style.top = '';
        stickyContainer.style.bottom = 0;
      }
    }
  }



  /* Oval Square and SecondFemale - Scrollbar for flickity sidescrolls with products   */
  
   //For flickity carousels
  document.querySelectorAll('.theme-oval_square .ProductList.ProductList--carousel[data-flickity-config]').forEach((carousel) => {      
    initiateScrollBarIndicator(carousel);
  });
   
  //For pdp carousel
  document.querySelectorAll('#images_container').forEach((carousel) => {      
    initiateScrollBarIndicator(carousel);
  });

  function initiateScrollBarIndicator(carousel) { 
    let flkty = null;
    
    if (carousel.hasAttribute('data-flickity-config')) {
      flkty = Flickity(carousel);
    }
    
    onLoad(flkty, carousel);

    if (flkty) {
      flkty.on( 'scroll', function( progress ) {
        listener(flkty, carousel, progress);
      });
    } else {
      let images = carousel.querySelectorAll('.Product__SlideItem');
      let slideWidth;
      
      images.forEach((productImage, i) => {
          if (!slideWidth && productImage.style.display !== 'none') {
            slideWidth = productImage.offsetWidth;
          }        
      });
      
      carousel.addEventListener('scroll', (event) => {
        let firstImageVisible = false;
        let amountOfImagesNotVisible = 0;
        images.forEach((productImage, i) => {
          if(firstImageVisible === false) {
            if (productImage.style.display !== 'none') {
              firstImageVisible = i;
            } else {
              amountOfImagesNotVisible++;
            }
          }
        })
        
        if(firstImageVisible === false) {
          return;
        }

        firstImageVisible = parseInt(firstImageVisible);

        let scrollLeft = carousel.scrollLeft;

        if(amountOfImagesNotVisible !== 0) {
          scrollLeft += amountOfImagesNotVisible * slideWidth;
        }
        
        let progress = scrollLeft / ((images.length * slideWidth) - window.innerWidth);
        
        listener(flkty, carousel, progress);
      });
    }

    window.addEventListener('resize', function(event) {
      setScrollbarIndicatorWidth(flkty, carousel);
    }, true);
  }
     
  function listener(flkty, carousel, progress) {
    setScrollbarIndicatorPosition(flkty, carousel, progress)
  }

  function onLoad(flkty, carousel) {     
    let section = carousel.closest('.shopify-section');

    let wrapper = section.querySelector('.ProductListWrapper');

    if (!wrapper) {
      wrapper = section.querySelector('.Product__Wrapper .Product__Gallery');
    }

    let scrollBar = '<div class="flickity_custom_scrollbar"><div class="flickity_custom_scrollbar_indicator"></div></div>';
      
    wrapper.insertAdjacentHTML('beforeend', scrollBar);

    let scrollbarIndicator = wrapper.querySelector('.flickity_custom_scrollbar_indicator');

    setScrollbarIndicatorWidth(flkty, carousel);
  }

  function setScrollbarIndicatorWidth(flkty, carousel) {    
    let scrollbarIndicator = carousel.closest('.shopify-section').querySelector('.flickity_custom_scrollbar_indicator');

    let presetWidth = scrollbarIndicator.getAttribute('data-width');

    if(presetWidth) {
      scrollbarIndicator.style.width = presetWidth;
      return;
    }
    
    let width = null; 
      
    if (flkty) {
      width = flkty.viewport.clientWidth / flkty.slideableWidth;
    } else {      
      width = carousel.offsetWidth / carousel.scrollWidth;
    }

    width = width * 100 + '%';

    scrollbarIndicator.setAttribute('data-width', width);
    scrollbarIndicator.style.width = width;
  }

  function setScrollbarIndicatorPosition(flkty, carousel, progress = false) {
    let scrollbar = carousel.closest('.shopify-section').querySelector('.flickity_custom_scrollbar');
    let scrollbarIndicator = carousel.closest('.shopify-section').querySelector('.flickity_custom_scrollbar_indicator');

    let scrollbarExcessWidth = scrollbar.offsetWidth - scrollbarIndicator.offsetWidth;

    let progression = null;

    if (progress) {
      progression = progress;
      
    } else if (flkty) {
      progression = (Math.round(flkty.slidesWidth) - (flkty.viewport.scrollWidth - flkty.viewport.clientWidth)) / Math.round(flkty.slidesWidth);
      
    } else {
      let images = carousel.querySelectorAll('.Product__SlideItem');
      let slideWidth;

      images.forEach((productImage) => {
        if (!slideWidth && productImage.style.display !== 'none') {
          slideWidth = productImage.offsetWidth;
        }
      })
      
      progression = (Math.round(slideWidth) - ((images.length * slideWidth) - carousel.offsetWidth)) / Math.round(slideWidth)
    }

    if(progression > 1) {
      progression = 1;
    } else if(progression < 0) {
      progression = 0;
    }
    
    scrollbarIndicator.style.marginLeft = scrollbarExcessWidth * progression + 'px';
  }



   
   document.addEventListener('DOMContentLoaded', () => {
     /* Oval Square - Remove products from cart if quantity 0 */ 
     setTimeout(() =>  {

      document.querySelectorAll(".theme-oval_square #sidebar-cart .QuantitySelector__CurrentQuantity").forEach((quantitySelector) => {
              
       quantitySelector.addEventListener('blur', (event) => {
         let value = event.target.value;
         
         if(value == 0) {
           setTimeout(() =>  {
             quantitySelector.closest('.CartItem__Actions').querySelector('.CartItem__Remove').click();
           }, 200);
         }
       })
     })
       
     }, 2000)

    /* Tooltip to color swatches */
     document.querySelectorAll(".template-product .ColorSwatchList .HorizontalList__Item").forEach((colorSwatchListItem) => {
       
       colorSwatchListItem.addEventListener('mouseenter', (event) => {
         let colorSwatchList = document.querySelector(".template-product .ColorSwatchList");
         let colorSwatch = event.target.querySelector(".ColorSwatch");

         colorSwatchList.setAttribute('data-tooltip', colorSwatch.getAttribute('data-tooltip'));
       })

       colorSwatchListItem.addEventListener('mouseleave', (event) => {
         let colorSwatchList = document.querySelector(".template-product .ColorSwatchList");
         let colorSwatchActive = document.querySelector(".template-product .ColorSwatchList .ColorSwatch.is-active");

         colorSwatchList.setAttribute('data-tooltip', colorSwatchActive.getAttribute('data-tooltip'));
       })
     })
  }, false);


  /* Filter color swatches clicks */
  document.querySelectorAll("#collection-filter-drawer .ColorSwatchList li.HorizontalList__Item").forEach((item) => {
    item.addEventListener('click', (event) => {
         item.querySelector(".ColorSwatch").click();
       })
  })


  /* Custom lightbox PDP */
  let images = document.querySelectorAll(".template-product #images_container .Product__SlideItem");
    
  images.forEach(async (slideItem) => {
    slideItem.addEventListener('click', (event) => {
      
      let productGallery = document.querySelector(".template-product .Product__Gallery");
      let imagesContainer = document.querySelector(".template-product .Product__Gallery #images_container");

      if(productGallery) {
        let isLightbox = productGallery.classList.contains('lightbox');
        let body = document.querySelector('body');
        
        if (isLightbox) {
          let formerlyVisible = productGallery.getAttribute('data-visibile-images');

          if(formerlyVisible) {
            formerlyVisible = JSON.parse(formerlyVisible);

            images.forEach((productImage, i) => {
              if(!formerlyVisible.includes(i)) {
                productImage.style.display = 'none';
              }
            })
          }
          
          productGallery.classList.remove('lightbox');
          productGallery.style.height = '';
          body.style.overflow = '';
          
        } else {
          if(window.innerWidth < 400) {
            return;
          }
          
          let visibleImages = [];

          images.forEach((productImage, i) => {
            if(productImage.style.display !== 'none') {
              visibleImages.push(i);
            } else {
              productImage.style.display = '';
            }
          })

          let clickedHeightPositionDecimal = event.offsetY / event.target.clientHeight;
          
          body.style.overflow = 'hidden';
          productGallery.style.height = productGallery.clientHeight + 'px';
          productGallery.classList.add('lightbox');
          productGallery.setAttribute('data-visibile-images', JSON.stringify(visibleImages));

          event.target.scrollIntoView();

          let clickedPosition = (event.target.clientHeight * clickedHeightPositionDecimal) - (screen.height / 3); //Making the image be scrolled top-centered, to the position clicked on the image

          imagesContainer.scrollBy(0,clickedPosition);
        }

        //Trigger resize event, to resize image sources
        window.dispatchEvent(new Event('resize'));
      }
   }) 
  })


  //Oval Square - Move currency converter widget to footer
  document.addEventListener('DOMContentLoaded', () => {

    //Give it 100 tries to move it to the footer
    for (var i = 0; i < 100; i++) {
      setTimeout(function () {
        //Find currency converter widget
        let currencyConverter = $(".theme-oval_square > .bacurr-cur-blocker");

        //If the currency converter widget is loaded
        if (currencyConverter.get(0)) {
          let columnIndex = window.innerWidth < 640 ? 3 : 1;
          
          let footerColumn = $("#shopify-section-footer .Footer__Inner .Footer__Block:nth-of-type("+columnIndex+") .Linklist");
          let footerHasCurrencyConverter = $("#shopify-section-footer .Footer__Inner .Footer__Block:nth-of-type("+columnIndex+") .Linklist .bacurr-cur-blocker");

          //Making sure it hasn't already been inserted
          if (!footerHasCurrencyConverter.get(0)) {
            currencyConverter.appendTo(footerColumn);

            let dropdownChoices = document.querySelector("#shopify-section-footer .Footer__Inner .bacurr-cur-blocker .bacurr-dropdownChoices");

            dropdownChoices.insertAdjacentHTML('afterbegin', '<span class="currency-title">currency: </span>');

            i = 10000;
          }
        }
      }, i * 50)
    }
    
  }, false);

  //SecondFemale - Ensure sidebar menu header has same height as header on mobile
  document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('body').classList.contains('theme-second_female')) {
      let sidebar_menu_header = document.querySelector('#shopify-section-sidebar-menu .Drawer__Header');
      
      
      if (!sidebar_menu_header) {
        return;
      }

      if (window.innerWidth < 1140) {
        let header = document.querySelector('#shopify-section-header');
        let height = header.offsetHeight; 
  
        let announcement_bar = document.querySelector('#shopify-section-announcement');
        if (announcement_bar) {
          height += announcement_bar.offsetHeight;
        }

        sidebar_menu_header.style.height = height + 'px';
      } else {
        sidebar_menu_header.style.ehgith = '81px';
      }
      
    }
  }, false);

  //SecondFemale - Move arrows on Clerk slider
  if(typeof Clerk !== "undefined") {
    Clerk('on', 'rendered', function(content, data) {    
      let id = data.content.id;

      if (id !== 'category-page-popular' && id !== 'product-page-alternatives') {
        return;
      }
      
      let clerkElement = document.querySelector('#'+id);

      let subClerkElement = clerkElement.querySelector('div[class^="clerk-design-component-"]');

      setTimeout(() => {
        let arrowPrev = clerkElement.querySelector('.clerk-slider-nav.clerk-slider-nav-prev');
        let arrowNext = clerkElement.querySelector('.clerk-slider-nav.clerk-slider-nav-next');
        
        subClerkElement.append(arrowPrev);
        subClerkElement.append(arrowNext);
      }, 2000)
      
    });
  }
  

   
  //SecondFemale - Ensure filters on PLP looks like they expanded from under the top part of the page
  document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('body').classList.contains('theme-second_female')) {
      let collectionFilterDrawer = document.querySelector('#collection-filter-drawer');

      let collectionToolbar = document.querySelector(".CollectionToolbar");
      
      if (!collectionFilterDrawer || !collectionToolbar) {
        return;
      }

      let rect = collectionToolbar.getBoundingClientRect();

      collectionFilterDrawer.style.paddingTop = rect.bottom + 'px';
      collectionFilterDrawer.style.marginTop = '-' + rect.bottom + 'px';
    }
  }, false);


  //Add class to HTML element, whether filter is visible or not
  document.addEventListener('DOMContentLoaded', () => {
    let html = document.querySelector("html");
    let collectionFilterDrawer = document.querySelector('.theme-second_female #collection-filter-drawer');
    
    if(!html || !collectionFilterDrawer) {
      return;
    }
    
    let observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        //If the visibility of the filter drawer has changed
        if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
          let filterIsHidden = collectionFilterDrawer.getAttribute('aria-hidden') === 'true';

          window.scrollTo({top: 0, behavior: 'smooth'}); //Scroll to top
          
          if (filterIsHidden) {
            html.classList.remove('filters-visible');
          } else {
            html.classList.add('filters-visible');
          }
        }
      });
    });
    
    observer.observe(collectionFilterDrawer, {
      attributes: true //configure it to listen to attribute changes
    });
    
  }, false);


  //Make filter button be able to close filters aswell
  document.addEventListener('DOMContentLoaded', () => {
    let html = document.querySelector("html");
    let toolbarFilterItem = document.querySelector('.theme-second_female .CollectionToolbar__Item--filter');
    
    if(!html || !toolbarFilterItem) {
      return;
    }

    toolbarFilterItem.addEventListener("click", () => {
      if (html.classList.contains('filters-visible')) {
        let closeButton = document.querySelector('#collection-filter-drawer button.Drawer__Close');
        setTimeout(() => {
          closeButton.click();
        }, 50)
      }
    })
  }, false);


  //Set height on collection banners
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector("body").classList.contains("theme-second_female") || !document.querySelector("body").classList.contains("template-collection")) {
      return;
    }
    
    setHeightOnCustomCollectionBanners();

    addEventListener('resize', (event) => {
      setHeightOnCustomCollectionBanners();
    });

    function setHeightOnCustomCollectionBanners() {
      let normalHeightGridCell = document.querySelector(".template-collection .CollectionInner__Products .ProductList .Grid__Cell:not(.Collection_banner)");

      document.querySelectorAll(".template-collection .CollectionInner__Products .ProductList .Grid__Cell.Collection_banner").forEach((collectionBanner) => {
        //Fade in
        let collectionBannerInner = collectionBanner.querySelector(".Collection_banner_inner");

        //Check if height has already been set on banner
        let heightIsAlreadySet = !!collectionBanner.style.height;

        if(!collectionBannerInner && !heightIsAlreadySet) {
          collectionBanner.style.opacity = 0;
        }

        if (normalHeightGridCell) {
          collectionBanner.style.height = normalHeightGridCell.querySelector(".ProductItem__ImageWrapper").offsetHeight + 'px';
        }

        if(!heightIsAlreadySet) {
          if(collectionBannerInner) {
            collectionBannerInner.style.opacity = 1;
          } else {
            setTimeout(() => {
              collectionBanner.style.transition = "opacity 0.5s ease";
              collectionBanner.style.opacity = 1;
              
              setTimeout(() => {
                collectionBanner.style.transition = "";
              }, 800);
            }, 10);
          }
        }
        
      })
    }
  }, false);


  //Move collection banners when switching screen sizes
  document.addEventListener('DOMContentLoaded', async () => {
    if (!document.querySelector("body").classList.contains("theme-second_female") || !document.querySelector("body").classList.contains("template-collection")) {
      return;
    }

    await resetOrdersOnCollectionItems();

    setCollectionBannersPlacements();

    addEventListener('resize', (event) => {
      setCollectionBannersPlacements();
    });

    // ensureCollectionBannersArePositionedCorrect();
    
    // addEventListener('resize', (event) => {
    //   ensureCollectionBannersArePositionedCorrect();
    // });

    function setCollectionBannersPlacements(timesRun = 0) {
      
      let allGridCells = document.querySelectorAll(".ProductList .Grid__Cell");
      let allGridCellsArray = Array.prototype.slice.call(allGridCells);
      
      if(timesRun === 0) {
        //Reset all grid items
        allGridCells.forEach((gridCell) => {
          if(gridCell.getAttribute("data-initial-position")) {
            gridCell.style.order = gridCell.getAttribute("data-initial-position") * 100;
          }
        })
      }

      let screenSize = window.innerWidth;
      let notAcceptablePositions = Array.from({length: allGridCellsArray.length}, (_, i) => i + 1);

      notAcceptablePositions = notAcceptablePositions.filter(function (notAcceptablePosition) {
          if (screenSize <= 640) { //Mobile              
            return notAcceptablePosition % 2 == 0; //All even numbers
            
          } else if(screenSize < 1008) { //Tablet
            return notAcceptablePosition % 3 == 0; //Every third number
            
          } else { //Web
            return notAcceptablePosition % 4 == 0; //Every fourth number
          }
      });

      let collectionBanners = document.querySelectorAll(".ProductList .Collection_banner.Collection_banner_double.Grid__Cell");

      let changesMade = 0;
      
      collectionBanners.forEach((collectionBanner) => {
        let previousDoubleBanners = getPreviousBanners(collectionBanner, true);
        
        let currentPosition = (collectionBanner.style.order / 100) + previousDoubleBanners.length;

        if(notAcceptablePositions.includes(currentPosition)) {
          let firstNormalGridCellBeforeOrder = getGridCellBeforeSpecificOrder(collectionBanner.style.order);
          
          if(firstNormalGridCellBeforeOrder) {            
            firstNormalGridCellBeforeOrder.style.order = collectionBanner.style.order;
            
            collectionBanner.style.order = collectionBanner.style.order - 100;

            changesMade++;
          }
        }
      })

      if(changesMade > 0) {
        return setCollectionBannersPlacements(timesRun + 1)
      }
    }

    function getGridCellBeforeSpecificOrder(order) {
      let desiredGridCell = false;

      let gridCells = document.querySelectorAll(".ProductList .Grid__Cell");

      //Turn it into an array
      gridCells = [...gridCells];
  
      // Sort the array based on the order style
      gridCells = gridCells.sort((a, b) => {
          let orderA = parseInt(window.getComputedStyle(a).order);
          let orderB = parseInt(window.getComputedStyle(b).order);
          return orderA - orderB;
      });

      //Reverse the array
      gridCells = gridCells.reverse();

      let doubleBannersMoved = 0;
      
      gridCells.forEach((gridCell) => {
        if(desiredGridCell) { //If already found
          return;
        }

        let isDoubleBanner = gridCell.classList.contains("Collection_banner_double");
        let gridCellOrder = parseInt(gridCell.style.order);

        if(gridCellOrder < order - (doubleBannersMoved * 100)) {
          if(isDoubleBanner) {
            gridCell.style.order = gridCell.style.order - 100;
            
            doubleBannersMoved++;
          } else {
            desiredGridCell = gridCell;
          }
        }
      })

      return desiredGridCell;
    }

    function ensureCollectionBannersArePositionedCorrect(timesRun = 0) {
      if(timesRun > 5) {
        return; //We assume we are infinitely looping
      }
      
      let collectionBanners = document.querySelectorAll(".ProductList .Collection_banner.Collection_banner_double.Grid__Cell");

      let changesMade = 0;
        
      collectionBanners.forEach((collectionBanner) => {
        // if(changesMade > 0) {
        //   return; //Skip
        // }
        
        let allGridCells = document.querySelectorAll(".ProductList .Grid__Cell");
        let allGridCellsArray = Array.prototype.slice.call(allGridCells);

        let previousBanners = getPreviousBanners(collectionBanner);
        let previousDoubleBanners = getPreviousBanners(collectionBanner, true); //We need this to calculate the current position, as double banners should count for two
        
        let originalPosition = (parseInt(collectionBanner.getAttribute("data-initial-position")) * 100) + (previousDoubleBanners.length * 100) ;
        // let currentPosition = allGridCellsArray.indexOf(collectionBanner) + 1 + previousBanners.length + previousDoubleBanners.length;
        let currentPosition = parseInt(collectionBanner.style.order) + (previousDoubleBanners.length * 100);

        let screenSize = window.innerWidth;
        let notAcceptablePositions = Array.from({length: allGridCellsArray.length}, (_, i) => i + 1);

        notAcceptablePositions = notAcceptablePositions.filter(function (notAcceptablePosition) {
            if (screenSize <= 640) { //Mobile              
              return notAcceptablePosition % 2 == 0; //All even numbers
              
            } else if(screenSize < 1008) { //Tablet
              return notAcceptablePosition % 3 == 0; //Every third number
              
            } else { //Web
              return notAcceptablePosition % 4 == 0; //Every fourth number
            }
        });

        console.log(notAcceptablePositions.includes(currentPosition / 100), (!notAcceptablePositions.includes(originalPosition / 100) && currentPosition != originalPosition));

        if (notAcceptablePositions.includes(currentPosition / 100) || (!notAcceptablePositions.includes(originalPosition / 100) && currentPosition != originalPosition)) { //Needs to be moved
          let newPosition = currentPosition + 100;
          let isMovingBackwards = false;
          
          console.log("new", newPosition, "original", originalPosition);
          
          if (!notAcceptablePositions.includes(originalPosition / 100)) { //If original position works fine
            let gridCellInOriginalPosition = getGridCellInNewPosition(originalPosition, true, true);

            if(!gridCellInOriginalPosition.classList.contains("Collection_banner_double")) {
              newPosition = originalPosition;
            } else {
              let firstFreePositionAfterOriginal = getFirstPositionAfterOriginalThatIsFree(originalPosition, collectionBanner, notAcceptablePositions);
              console.log("FIRST FREE", firstFreePositionAfterOriginal);
              
              if(!firstFreePositionAfterOriginal /*|| firstFreePositionAfterOriginal < newPosition*/) {
                // console.log("Don't move", collectionBanner.id)
                // return false;
              } else {
                newPosition = firstFreePositionAfterOriginal;
              }
              
            }
          }
            
          if(newPosition < currentPosition) {
            isMovingBackwards = true;
          }

          console.log(notAcceptablePositions, "current", currentPosition, "original", originalPosition, "new", newPosition);

          let gridCellInNewPosition = getGridCellInNewPosition(newPosition, isMovingBackwards);

          console.log(collectionBanner, gridCellInNewPosition);

          if(gridCellInNewPosition) {
            let gridCellInNewPositionsNewPosition = isMovingBackwards ? newPosition + 100 : newPosition - 100;
            let gridCellInNewPositionShouldReturnToItsOriginalPosition = (parseInt(gridCellInNewPosition.getAttribute("data-initial-position")) * 100) < newPosition && gridCellInNewPositionsNewPosition > newPosition;
            
            collectionBanner.style.order = newPosition;
            
            gridCellInNewPosition.style.order = gridCellInNewPositionShouldReturnToItsOriginalPosition ? (parseInt(gridCellInNewPosition.getAttribute("data-initial-position")) * 100) : gridCellInNewPositionsNewPosition;
            
            gridCellInNewPosition.before(collectionBanner);
            
            changesMade++;
          }
        }
      })

      if(changesMade > 0) {
        resetOrdersOnCollectionItems();
        
        ensureCollectionBannersArePositionedCorrect(timesRun + 1); ///Run it again, to make sure the changes hasn't created new problems
      }
    }

    async function resetOrdersOnCollectionItems() {
      let collectionItems = document.querySelectorAll(".ProductList .Grid__Cell");

      // Convert NodeList to an array for sorting
      let collectionItemsArray = Array.from(collectionItems);
  
      // Sort the array based on the order style
      let sortedCollectionItems = collectionItemsArray.sort((a, b) => {
          let orderA = parseInt(window.getComputedStyle(a).order);
          let orderB = parseInt(window.getComputedStyle(b).order);
          return orderA - orderB;
      });
  
      // Reset the order values
      return sortedCollectionItems.forEach((collectionItem, i) => {
          collectionItem.style.order = (i + 1) * 100;
        
          if(!collectionItem.getAttribute('data-initial-position')) {
            collectionItem.setAttribute('data-initial-position', i + 1);
          }
      });
    }

    function getPreviousBanners(element, doubleOnly = false) {
      var siblings = [];
      var prevSibling = element.previousElementSibling;
  
      while (prevSibling) {
          if (doubleOnly && prevSibling.classList.contains("Collection_banner_double")) {
              siblings.push(prevSibling);
          } else if(!doubleOnly && prevSibling.classList.contains("Collection_banner")) {
              siblings.push(prevSibling);
          }
          prevSibling = prevSibling.previousElementSibling;
      }
  
      return siblings;
    }

    function getGridCellInNewPosition(position, isMovingBackwards, includeDoubleBanners = false) {
      let gridCellInPosition = false;

      let gridCells = document.querySelectorAll(".ProductList .Grid__Cell");

      //Turn it into an array
      gridCells = [...gridCells];
  
      // Sort the array based on the order style
      gridCells = gridCells.sort((a, b) => {
          let orderA = parseInt(window.getComputedStyle(a).order);
          let orderB = parseInt(window.getComputedStyle(b).order);
          return orderA - orderB;
      });

      //If we are moving backwards, reverse the array
      if(isMovingBackwards) {
        gridCells = gridCells.reverse();
      }
      
      gridCells.forEach((gridCell) => {
        if(gridCellInPosition) { //If already found
          return;
        }

        let isDoubleBanner = gridCell.classList.contains("Collection_banner_double");
        
        if((!isDoubleBanner || includeDoubleBanners) && ((gridCell.style.order >= position && !isMovingBackwards) || (gridCell.style.order <= position && isMovingBackwards))) {
          
          gridCellInPosition = gridCell;
        }
      })

      return gridCellInPosition;
    }

    function getFirstPositionAfterOriginalThatIsFree(originalPosition, currentGridCell, notAcceptablePositions) {
      let collectionItems = document.querySelectorAll(".ProductList .Grid__Cell");

      // Convert NodeList to an array for sorting
      let collectionItemsArray = Array.from(collectionItems);
  
      // Sort the array based on the order style
      let sortedCollectionItems = collectionItemsArray.sort((a, b) => {
          let orderA = parseInt(window.getComputedStyle(a).order);
          let orderB = parseInt(window.getComputedStyle(b).order);
          return orderA - orderB;
      });

      let firstPositionFree = false;

      let doubleBannersSoFar = 0;
      
      sortedCollectionItems.forEach((sortedCollectionItem) => {
        if(firstPositionFree !== false) {
          return;
        }
        let isDoubleBanner = sortedCollectionItem.classList.contains("Collection_banner_double");
        
        let order = parseInt(sortedCollectionItem.style.order);
        let calculatedOrder = order + (doubleBannersSoFar * 100);

        if(calculatedOrder >= originalPosition && (!isDoubleBanner || currentGridCell.id === sortedCollectionItem.id) && !notAcceptablePositions.includes(calculatedOrder / 100)) {
          console.log("Test", calculatedOrder >= originalPosition, [!isDoubleBanner, currentGridCell.id === sortedCollectionItem.id], !notAcceptablePositions.includes(calculatedOrder / 100))
          firstPositionFree = calculatedOrder;
        }

        if(isDoubleBanner) {
          doubleBannersSoFar++;
        }
      })

      return firstPositionFree;
    }
    
  }, false);

   //Low in stock toggle for variants
   document.addEventListener('DOMContentLoaded', () => {
     if (!document.querySelector("body").classList.contains("theme-second_female") || !document.querySelector("body").classList.contains("template-product")) {
       return;
     }

     //Variant ID on load
     let currentVariantId = document.querySelector(".ProductForm .ProductForm__Variants select[name='id']").value;
     toggleLowInStock(currentVariantId);;

     //Listener on change
     document.addEventListener('variant:changed', function(event) {       
      if (event.detail && event.detail.hasOwnProperty('variant')) {
        let newVariant = event.detail.variant;

        toggleLowInStock(newVariant.id.toString());

        //Add to cart button back to primary, if product is in stock
        //Resolves a bug, where the add to cart button get class "secondary" when viewing a variant with no stock, but the class is not removed when clicking back to a in-stock variant
        setTimeout(() => {
          let addToCartButton = document.querySelector(".template-product .ProductForm .ProductForm__AddToCart");

          if (addToCartButton && addToCartButton.getAttribute('data-action') === "add-to-cart") {
            addToCartButton.classList.remove("Button--secondary");
          }
        }, 50)
      }
      
    });


    function toggleLowInStock(newVariantId) {
      let lowInStockElement = document.querySelector(".Low-in-stock");
      lowInStockElement.classList.remove('show');

      if (!lowInStockElement) {
        return;
      }
      
      let variants = JSON.parse(lowInStockElement.getAttribute('data-variants'));

      if (!variants) {
        return;
      }
      
      let showLowInStock = variants.includes(newVariantId);

      if (showLowInStock) {
        setTimeout(() => {
          lowInStockElement.classList.add('show');
        }, 100);
      }
    }
  }, false);


   //Ønskeskyen buttons, make function to click button, when container is clicked
  document.addEventListener('DOMContentLoaded', () => {
    //Only for SecondFemale right now
    if (!document.querySelector("body").classList.contains("theme-second_female")) {
     return;
   }
    
    let onskeskyenButton = document.querySelector(".ProductForm .ov-onskeskyen-container");

    if (!onskeskyenButton) {
      return;
    }
    
    onskeskyenButton.addEventListener('click', function(event) {
     event.target.querySelector("#ov-onskeskyen-generated-wish-button").click();
    }) 
  }, false);

   
  //Sticky add to cart button
  document.addEventListener('DOMContentLoaded', () => {
    //Checking if we are on product page (PDP)
    if (!document.querySelector("body").classList.contains("template-product")) {
      return;
    }

    let StickyAddToCartContainer = document.querySelector(".ProductForm__AddToCart__Sticky_Container");
    let StaticAddToCartContainer = document.querySelector(".ProductForm > .ProductForm__AddToCart__Container");

    //If button is not supposed to be sticky
    if (!StickyAddToCartContainer || !StaticAddToCartContainer) {
      return;        
    }

    //Adding a class to body, for potential styling
    let body = document.querySelector('body');
    let bodyStickyButtonClass = 'has-sticky-add-to-cart-button';
    if (!body.classList.contains(bodyStickyButtonClass)) {
      body.classList.add(bodyStickyButtonClass);
    }

    //For scroll
    addEventListener('scroll', (event) => {
      controlStickyAddToCartButtonOnProductPage(StickyAddToCartContainer, StaticAddToCartContainer);
    });

    //For resize
    addEventListener('resize', (event) => {
      //Remove Sticky class, to reset the position on page
      StickyAddToCartContainer.classList.remove('Sticky');
      controlStickyAddToCartButtonOnProductPage(StickyAddToCartContainer, StaticAddToCartContainer);
    });

    //For clicks on button
    let stickyAddToCartButton = StickyAddToCartContainer.querySelector('.ProductForm__AddToCart');
    stickyAddToCartButton.addEventListener('click', (event) => {
      scrollToFormAfterClickingStickyAddToCart();

      //Remove hover from button a little after scrolling away, so if scrolling down again, the button will not be focused
      setTimeout(() => {
        event.target.blur();
        event.target.parentNode.click();
      }, 300)
    })
    
    function controlStickyAddToCartButtonOnProductPage(StickyAddToCartContainer, StaticAddToCartContainer) {
      let screenWidth = screen.width;
      let showStickyButton = null;

      if (screenWidth >= 1008) {
        showStickyButton = false;
      }

      let windowScrollYTop;
      let windowScrollYBottom;

      //If we are in the screen width where the sticky Add to cart button is active
      if (showStickyButton !== false) {
        windowScrollYTop = window.scrollY;
        windowScrollYBottom = windowScrollYTop + window.outerHeight;

        if (!StickyAddToCartContainer.classList.contains('Sticky')) {
          let StaticAddToCartContainerClientRect = StaticAddToCartContainer.getBoundingClientRect();
          StaticAddToCartContainer.setAttribute('data-position-y-top', StaticAddToCartContainerClientRect.top + windowScrollYTop);
          StaticAddToCartContainer.setAttribute('data-position-y-bottom', StaticAddToCartContainerClientRect.bottom + windowScrollYTop);
        }

        let announcementBar = document.querySelector("#shopify-section-announcement");
        let header = document.querySelector("#shopify-section-header");
        
        let dataPositionYTop = Number(StaticAddToCartContainer.getAttribute('data-position-y-top'));
        let dataPositionYBottom = Number(StaticAddToCartContainer.getAttribute('data-position-y-bottom')) - announcementBar.clientHeight - header.clientHeight;
        
        if (window.scrollY !== 0 && (/*dataPositionYTop > windowScrollYBottom ||*/ dataPositionYBottom < windowScrollYTop)) {
          showStickyButton = true;
        } else {
          showStickyButton = false;
        }
      }

      if (showStickyButton) {
        StickyAddToCartContainer.classList.add('Sticky');
        
      } else {
        StickyAddToCartContainer.classList.remove('Sticky');
      }
    }

    function scrollToFormAfterClickingStickyAddToCart() {
      let productForm = document.querySelector(".Product__Wrapper .Product__InfoWrapper");
      let productFormRect = productForm.getBoundingClientRect();
      
      
      window.scrollBy({
        top: productFormRect.top - 300,
        left: 0,
        behavior: 'smooth'
      })
    }
    
  }, false);

  //For custom swym wishlist buttons 
  // document.addEventListener('DOMContentLoaded', () => {
  //   //Listener on change
  //   document.addEventListener('variant:changed', function(event) {       
  //   if (event.detail && event.detail.hasOwnProperty('variant')) {
  //     let newVariant = event.detail.variant;
    
  //     document.querySelectorAll(".swym-button.swym-add-to-wishlist.swym-button-custom").forEach((customAddToWishlistButton) => {
  //       customAddToWishlistButton.setAttribute("data-variant-id", newVariant.id);
  //     })
  //   }
    
  //   });
  // }, false);


  //Making sure second image on PDP lazy loads from load on mobile
  document.addEventListener('DOMContentLoaded', () => {
    let isProductPage = document.querySelector('body').classList.contains('template-product') && document.querySelector('body').classList.contains('theme-second_female');

    if (!isProductPage) {
      return;
    }

    let imagesContainer = document.querySelector('#images_container');
    let firstImage = imagesContainer.querySelector('.Product__SlideItem:nth-of-type(1)');
    let secondImage = imagesContainer.querySelector('.Product__SlideItem:nth-of-type(2)');
    let secondImageRect = secondImage.getBoundingClientRect();

    setTimeout(() => {
      // Sliding to second image, to make sure it loads
      imagesContainer.scrollLeft = secondImageRect.left - (secondImage.clientWidth * 0.6); //Scroll 40% in to second image
      
      // Sliding back to first image
      setTimeout(() => {
        slideMostViewedImageToTheLeft(images_container);
      }, 350)
    }, 150)
    
  }, false);


  //Enabling scroll on element in sidebar cart by manually opening and closing sidebar cart, as some standard JS disables scroll in sidebar cart, when using regular open and close functions
  document.addEventListener('DOMContentLoaded', () => {
    let is_second_female = document.querySelector('body').classList.contains('theme-second_female')
    let sidebar_cart_toggles = document.querySelectorAll('a[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    let sidebar_cart = document.querySelector('#sidebar-cart');
    let upselling_container = document.querySelector('#sidebar-cart .cart_upselling_container');

    if (!is_second_female || !sidebar_cart_toggles || !sidebar_cart || !upselling_container) {
      return;
    }

    let upselling_container_html = upselling_container.outerHTML;

    sidebar_cart_toggles.forEach((sidebar_cart_toggle) => {
      sidebar_cart_toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        let page_overlay = document.querySelector('.PageOverlay');
        let html_element = document.querySelector('html');
        let close_sidebar_cart = document.querySelector('#sidebar-cart button.Drawer__Close ');

        sidebar_cart.setAttribute('aria-hidden', false);
        html_element.classList.add('no-scroll');
        page_overlay.classList.add('is-visible');

        //Adding own event listener for closing the Cart
        close_sidebar_cart.addEventListener('click', customCloseSidebarCart);

        function customCloseSidebarCart() {
          let page_overlay = document.querySelector('.PageOverlay');
          let html_element = document.querySelector('html');
          let close_sidebar_cart = document.querySelector('#sidebar-cart button.Drawer__Close ');

          sidebar_cart.setAttribute('aria-hidden', true);
          html_element.classList.remove('no-scroll');
          page_overlay.classList.remove('is-visible');

          //Removing the event listener for closing the sidebar cart, as it will be added again next time
          close_sidebar_cart.removeEventListener('click', customCloseSidebarCart)
        }
      })
      
      
    })

  }, false);


  document.addEventListener('DOMContentLoaded', () => {
    let is_second_female = document.querySelector('body').classList.contains('theme-second_female');

    if (!is_second_female) {
      return;
    }

    if(typeof Clerk !== "undefined") {
      Clerk('on', 'rendered', function(content, data) {
        let clerkWishlistButtons = document.querySelectorAll("span.clerk .swym-button.swym-add-to-wishlist");

        clerkWishlistButtons.forEach((clerkWishlistButton) => {
          clerkWishlistButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            customWishlistRemoveBtnClick(event);
          })
        })
      });
    }
    

    async function customWishlistRemoveBtnClick(e) {
      e.preventDefault();
      var epi = +e.currentTarget.getAttribute("data-variant-id");
      var empi = +e.currentTarget.getAttribute("data-product-id");

      window._swat.fetch(function(products) {
		products.forEach(function(product) {          
			if (epi && product.epi == epi){
              console.log('found product for removal');
              
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
      })
      
      
    }
  }, false);


  //Add class to body when cart is open
  document.addEventListener('DOMContentLoaded', () => {
    
    let observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        
        //If the visibility has changed
        if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
          let target = mutation.target;
          let isVisible = target.getAttribute("aria-hidden") === 'false';

          let type;

          if (target.id === "sidebar-cart") {
            type = "cart_drawer";
          } else if(target.classList.contains('MegaMenu')) {
            type = "mega_menu";
          }

          if(type === "mega_menu" && !isVisible) {
            let hasOtherMegaMenuBeenActivated = false;
            let megaMenuItems = document.querySelectorAll(".Header__MainNav .HorizontalList__Item .MegaMenu");
            megaMenuItems.forEach((megaMenuItem) => {
              if(megaMenuItem.getAttribute("aria-hidden") === 'false') {
                hasOtherMegaMenuBeenActivated = true;
              }
            })

            if(hasOtherMegaMenuBeenActivated) {
              isVisible = true;
            }
          }

          let body = document.querySelector("body");
          if (isVisible) {
            body.classList.add(type + '_visible');
          } else {
            body.classList.remove(type + '_visible');
          }

          document.dispatchEvent(new CustomEvent(type+':visibility', {
            detail: {
               visible: isVisible,
            }
          }));
        }
      });
    });

    let observerSettings = {
      attributes: true //configure it to listen to attribute changes
    };

    //Cart observer
    let cartDrawer = document.querySelector("#sidebar-cart");
    observer.observe(cartDrawer, observerSettings);

    //Mega menu observer
    let megaMenus = document.querySelectorAll("header nav .MegaMenu");
    megaMenus.forEach((megaMenu) => {
      observer.observe(megaMenu, observerSettings);
    })
    
  }, false);

  //PDP Images sidescroll on mobile - Make images stick to left, after scroll
  document.addEventListener('DOMContentLoaded', () => {
    let is_second_female = document.querySelector('body').classList.contains('theme-second_female');
    let isProductPage = document.querySelector('body').classList.contains('template-product');

    if (!isProductPage || !is_second_female) {
      return;
    }

    let images_container = document.querySelector("#images_container");

    //Make sure you can only scroll one image at a time
    let initialScrollPosition = images_container.scrollLeft;
    
    let firstVisibleImageIndex = images_container.getAttribute("data-first-visible") ? parseInt(images_container.getAttribute("data-first-visible")) : 0;
    let firstVisibleImage = images_container.querySelectorAll(".Product__SlideItem")[firstVisibleImageIndex];
    let firstVisibleImageLeftNeighbor = images_container.querySelectorAll(".Product__SlideItem")[firstVisibleImageIndex - 1];
    
    let maxScrollRangeRight = firstVisibleImage.clientWidth;
    let maxScrollRangeLeft = Math.abs( firstVisibleImageLeftNeighbor ? firstVisibleImageLeftNeighbor.clientWidth : 0 );

    let timeout;
    let maxScrollTimeout;

    images_container.addEventListener("scroll", (event) => {      
      return;
      
      let isSlider = screen.width <= 980;
      
      let isLightbox = document.querySelector(".Product__Gallery.lightbox");
      
      if (isLightbox || !isSlider) {
        return;
      }

      let currentScrollPosition = images_container.scrollLeft;
      let scrollDiff = Math.abs ( currentScrollPosition - initialScrollPosition );
      
      //If scrolled too far left
      let scrollingSide = currentScrollPosition >= initialScrollPosition ? 'right' : 'left';
      let maxPosition = false;
      
      if (scrollingSide === "left" && scrollDiff > maxScrollRangeLeft) {
        maxPosition = initialScrollPosition - maxScrollRangeLeft;
        
      } else if(scrollingSide === "right" && scrollDiff > maxScrollRangeRight) {
        maxPosition = initialScrollPosition + maxScrollRangeRight;
      }

      if (maxPosition) {        
        if (images_container.style.overflow !== "hidden") {
          console.log(scrollingSide, maxPosition);
          images_container.scrollTo({ top: 0, left: maxPosition, behavior: "smooth"});
          images_container.style.overflow = "hidden";
        }
        window.clearTimeout(maxScrollTimeout);
        maxScrollTimeout = setTimeout(() => {
          images_container.style.overflow = "";
        }, 100)
      }

      window.clearTimeout(timeout);
      currentScrollPosition = images_container.scrollLeft;
      timeout = setTimeout(function(){
        if (images_container.scrollLeft === currentScrollPosition) {
          initialScrollPosition = currentScrollPosition;

          firstVisibleImageIndex = images_container.getAttribute("data-first-visible") !== null ? parseInt(images_container.getAttribute("data-first-visible")) : firstVisibleImageIndex + (scrollingSide === "left" ? -1 : 1);
          firstVisibleImage = images_container.querySelectorAll(".Product__SlideItem")[firstVisibleImageIndex];
          firstVisibleImageLeftNeighbor = images_container.querySelectorAll(".Product__SlideItem")[firstVisibleImageIndex - 1];
    
          maxScrollRangeRight = firstVisibleImage.clientWidth;
          maxScrollRangeLeft = Math.abs( firstVisibleImageLeftNeighbor ? firstVisibleImageLeftNeighbor.clientWidth : 0 );
        }
      }, 100)
    })

    let isTouching;
    
    //When finger realeases from screen
    images_container.addEventListener("touchend", (event) => {
    	// Clear our timeout if another touch
    	window.clearTimeout( isTouching );
    
    	// Set a timeout to run after touching
    	isTouching = setTimeout(function() {
          
    		// Slide the image most on screen, to the left side
    		slideMostViewedImageToTheLeft(images_container);
    
    	}, 10);
    })
  }, false);

  function slideMostViewedImageToTheLeft(images_container) {      
    let isSlider = screen.width <= 1008;
    
    let isLightbox = document.querySelector(".Product__Gallery.lightbox");
    
    if (isLightbox || !isSlider) {
      return;
    }

    let scrollLeft = images_container.scrollLeft;
    
    setTimeout(() => {
      let newScrollLeft = images_container.scrollLeft;

      //Make sure scrolling has stopped
      if (scrollLeft !== newScrollLeft) {
        return slideMostViewedImageToTheLeft(images_container);
      }

      let productImages = images_container.querySelectorAll(".Product__SlideItem")
      
      scrollImageMostInViewToTheLeft(images_container, productImages);
    }, 50);

    
  }


  function scrollImageMostInViewToTheLeft(imagesContainer, images) {
    let foundDesiredImage = false;
    let marginLeftOnScroll = false;
     
    //Loop through images
    images.forEach((productImage, i) => {
      if (foundDesiredImage) {
        return;
      }

      if (i === 0) {
        marginLeftOnScroll = parseInt(window.getComputedStyle(productImage).marginLeft.replace("px", ""));
      }
      
      let imagesContainerRect = imagesContainer.getBoundingClientRect();
      let productImageRect = productImage.getBoundingClientRect();
      let imagesContainerWidth = imagesContainer.clientWidth
      
      //Find positions
      let imagesContainerPositionLeft = imagesContainerRect.left;
      let productImagePositionLeft = productImageRect.left - imagesContainerPositionLeft;
      let productImagePositionLeftOutOfScreen = productImagePositionLeft < 0 || productImagePositionLeft > imagesContainerWidth;
      let productImagePositionRight = productImageRect.right - imagesContainerPositionLeft;
      let productImagePositionRightOutOfScreen = productImagePositionRight < 0 || productImagePositionRight > imagesContainerWidth;
      let productImageWidth = productImage.clientWidth;
    
      //Find percent visible of image
      let percentVisible = false;
      let productImageVisible = productImageWidth;
    
      //If left side is outside screen, subtract from total visible
      if (productImagePositionLeftOutOfScreen) {
        productImageVisible = productImageVisible + productImagePositionLeft;
      }
    
      //If right side is outside screen, subtract from total visible
      if (productImagePositionRightOutOfScreen) {
        productImageVisible = productImageVisible + (imagesContainerWidth - productImagePositionRight);
      }
    
      //If entire image is outside screen, set productImageVisible to 0
      if (productImagePositionLeftOutOfScreen && productImagePositionRightOutOfScreen) {
        productImageVisible = 0;
      }
    
      percentVisible = (productImageVisible / productImageWidth) * 100;
      
      if (percentVisible > 50) {
        foundDesiredImage = true;
        imagesContainer.setAttribute("data-first-visible", i);

        //Ensures only being able to scroll one image at a time
        // hidePdpImagesNotNeeded(i, images, imagesContainer, productImageWidth);
        
        let isLastImage = images.length - 1 == i;
    
        if (productImagePositionLeft !== 0) {
    
          setTimeout(() => {
            let isScrolledAllRightSide = imagesContainer.scrollLeft >= imagesContainer.scrollWidth - imagesContainer.clientWidth;
            let newScrollPosition = imagesContainer.scrollLeft + productImagePositionLeft
            
            if (i === 0) {
              newScrollPosition = 0;
            }
            
            if (images.length -1 !== i && marginLeftOnScroll !== false && typeof marginLeftOnScroll === 'number') {
              newScrollPosition -= marginLeftOnScroll;
            }

            // if (!isScrolledAllRightSide) {
              imagesContainer.scrollLeft = newScrollPosition;
            // }
          }, 10)
        }
      }        
    }) 
  }

  function hidePdpImagesNotNeeded(index, images, imagesContainer, productImageScrollWidth) {
    
    let imageBeforeIndex = index - 1;
    let imageAfterIndex = index + 1;
    let index2 = false;
    
    //On bigger mobile and tablet sizes, there is 2 images visible in the slider, but also max 2
    let isMultiImageView = screen.width > 480;
    if (isMultiImageView) {
      index2 = imageAfterIndex;
      imageAfterIndex = imageAfterIndex + 1;
    }
    
    let allowedIndexes = [
      imageBeforeIndex, /* Image outside screen on the left */
      index, /* Image visible */
      imageAfterIndex, /* Image outside screen on the left */
    ];

    if(index2) {
      allowedIndexes.push(index2);
    }

    let firstImageToBeMadeVisible = false;
    
    setTimeout(() => {
      let newScrollPosition = false;
      
      if(imageBeforeIndex === -1) { //On first image
        newScrollPosition = 0;
      } else if (imageAfterIndex === images.length) { //On last image
        newScrollPosition = productImageScrollWidth * (allowedIndexes.length - 1);
      } else {
        newScrollPosition = productImageScrollWidth;
      }

      imagesContainer.scrollTo({ top:0, left:newScrollPosition, behavior: "instant"})
      
      images.forEach((productImage, i) => {
        if(allowedIndexes.includes(i)) {          
          productImage.style.display = '';
        } else {
          productImage.style.display = 'none';
        }
      }) 
    }, 150)
  }


   // Combat problem with videos not having the same height as images on PDP

  document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector("body").classList.contains("theme-second_female") && document.querySelector("body").classList.contains("template-product")) {
    //On load
    pdpVideosSameHeightAsImages()

    addEventListener('resize', (event) => {
      pdpVideosSameHeightAsImages();
    });     
   }
  });

   
  function pdpVideosSameHeightAsImages() {
    let images_container = document.querySelector("#images_container");

    if(!images_container) {
      return;
    }

    let productImages = images_container.querySelectorAll(".Product__SlideItem")

    if(!productImages || productImages.length === 0) {
      return;
    }

    let images = [];
    
    productImages.forEach((productImage, i) => {
      let isVideo = productImage.classList.contains("Product__SlideItem--video");      
      if(isVideo) {
        if(images.length > 0) {
          let nearestImage = images[images.length - 1];
          
          if (!nearestImage) {
            return;
          }

          let nearestImageAspectRatio = nearestImage.querySelector(".AspectRatio");

          if(!nearestImageAspectRatio) {
            return;
          }

          let newHeight = nearestImageAspectRatio.clientHeight;

          let videoWrapper = productImage.querySelector(".VideoWrapper");
          let video = productImage.querySelector(".VideoWrapper video");
          
          if(!videoWrapper || !video || !newHeight) {
            return;
          }

          videoWrapper.style.paddingBottom = newHeight + 'px';
          video.style.height = newHeight + 'px';
          video.style.objectFit = 'cover';
        }
      } else {
        images.push(productImage);
      }
    })
  }

   
   

  //Cart upselling navigation arrows 
  document.addEventListener('DOMContentLoaded', () => {
    let cartNavigationArrows = document.querySelectorAll(".cart_upselling_container .cart_upselling_navigation-item");
    
    let cartUpsellingCollectionContainer;
    let cartUpsellingCollection;

    //When cart opens and closes
    document.addEventListener("cart_drawer:visibility", (event) => {
      initiateUpsellingContainer(event);
    });

    function initiateUpsellingContainer(event, retries = 0) {
      console.log("Running now, have previously tried " + retries + " times")
      if(retries >= 3) {
        return;
      }

      cartNavigationArrows = document.querySelectorAll(".cart_upselling_container .cart_upselling_navigation-item");

      cartUpsellingCollectionContainer = document.querySelector(".cart_upselling_collection_container");
      cartUpsellingCollection = document.querySelector(".cart_upselling_collection");

      console.log(cartUpsellingCollectionContainer, cartUpsellingCollection);

      if(!cartUpsellingCollectionContainer || !cartUpsellingCollection) {
        console.log("Should run a retry now")

        return setTimeout(() => {
          return initiateUpsellingContainer(event, retries++);
        }, 1000)
      }
      
      //On init,  check if buttons should be usable
      cartNavigationCheckIfArrowsAreClickable();

      //On init, insert click event listeners on buttons for movement
      cartNavigationClickEventListener();
      
      if (event.detail.visible) {
        document.querySelector(".cart_upselling_collection_container").addEventListener("scroll", cartNavigationScrollEventListener );
        
        document.querySelector(".cart_upselling_collection_container").addEventListener("touchend", cartNavigationTouchEventListener );
      } else {
        cartUpsellingCollectionContainer.removeEventListener("scroll", cartNavigationScrollEventListener);
      }
    }

    function cartNavigationCheckIfArrowsAreClickable() {
      

      let scrollLeft = cartUpsellingCollectionContainer.scrollLeft;
      let maxLeftScroll = 0;

      let scrollRight = scrollLeft + cartUpsellingCollectionContainer.clientWidth;
      let maxRightScroll = cartUpsellingCollectionContainer.scrollWidth;
      

      cartNavigationArrows.forEach((cartNavigationArrow) => {
        let arrowDirection = cartNavigationArrow.getAttribute("data-direction");
        cartNavigationArrow = document.querySelector(".cart_upselling_navigation-item[data-direction='"+ arrowDirection +"']"); //Element has to be queryed here again, even though it is the same element
        
        if ((arrowDirection === "left" && scrollLeft === maxLeftScroll) || (arrowDirection === "right" && scrollRight === maxRightScroll)) {
          cartNavigationArrow.classList.add("disabled");
          
        } else if(cartNavigationArrow.classList.contains("disabled")) {
          cartNavigationArrow.classList.remove("disabled");
          
        }
      })
    }

    function cartNavigationScrollEventListener() {
      //On scroll, check if buttons should be usable
      cartNavigationCheckIfArrowsAreClickable();
      
      
    }

    let isTouching;

    function cartNavigationTouchEventListener() {
      let scrollLeft = cartUpsellingCollectionContainer.scrollLeft;

      setTimeout(() => {
        let newScrollLeft = cartUpsellingCollectionContainer.scrollLeft;

        //Make sure scrolling has stopped
        if (scrollLeft !== newScrollLeft) {
          return cartNavigationTouchEventListener();
        }

        // Clear our timeout if another touch
        window.clearTimeout( isTouching );
    
        // Set a timeout to run after touching
        isTouching = setTimeout(function() {
    
            // 
            scrollImageMostInViewToTheLeft(cartUpsellingCollectionContainer, cartUpsellingCollectionContainer.querySelectorAll(".cart_upselling_item"))
    
        }, 40);
      }, 50);

      
      
    }

    function cartNavigationClickEventListener() {
      //On scroll, check if buttons should be usable
      cartNavigationArrows.forEach((cartNavigationArrow) => {
        let arrowDirection = cartNavigationArrow.getAttribute("data-direction");
        cartNavigationArrow = document.querySelector(".cart_upselling_navigation-item[data-direction='"+ arrowDirection +"']"); //Element has to be queryed here again, even though it is the same element
        
        //Add click function on arrow
        cartNavigationArrow.addEventListener("click", () => {
          if (cartNavigationArrow.classList.contains("disabled")) {
            return;
          }
          
          let imagesToScrollPerClick = 2;          
          let cartUpsellingItems = document.querySelectorAll(".cart_upselling_collection .cart_upselling_item");
          let widthToScroll = 0;
          
          for(var i = 1; i < imagesToScrollPerClick + 1; i++){
            let image = cartUpsellingItems[i];
            let imageWidth = image.clientWidth;
            let marginLeft = parseInt(window.getComputedStyle(image).marginLeft.replace("px", ""));
            let marginRight = parseInt(window.getComputedStyle(image).marginRight.replace("px", ""));

            if (typeof marginLeft !== 'number') {
              marginLeft = 0;
            }

            if (typeof marginRight !== 'number') {
              marginRight = 0;
            }
            
            widthToScroll += imageWidth + marginLeft + marginRight;
          }

          let newScrollPosition = cartUpsellingCollectionContainer.scrollLeft + widthToScroll;

          if (arrowDirection === "left") {
            newScrollPosition = cartUpsellingCollectionContainer.scrollLeft - widthToScroll;
          }

          //If scrolled max left
          let maxScrollLeft = false;
          if (0 > newScrollPosition) {
            newScrollPosition = 0;
            maxScrollLeft = true;
          }

          //If scrolled max right;
          let maxScrollRight = false;
          let maxScrollRightPosition = cartUpsellingCollectionContainer.scrollWidth - cartUpsellingCollectionContainer.clientWidth;
          if (maxScrollRightPosition - 20 <= newScrollPosition) { //If within 20px of the end, assume the user wants to go to the end
            newScrollPosition = maxScrollRightPosition;
            maxScrollRight = true;
          }

          let dividedScroll = (newScrollPosition / widthToScroll);
          let dividedScrollDecimal = dividedScroll % 1;

          //If position is odd on screen, align to edge, unless it is maxed to a side
          if (dividedScrollDecimal !== 0 && !maxScrollLeft && !maxScrollRight) {
            newScrollPosition = Math.round(dividedScroll) * widthToScroll;
          }

          cartUpsellingCollectionContainer.scrollLeft = newScrollPosition;
        })
      })
    }
  }, false);


   //Refresh page on Cookiebot Deny, to make sure images are loaded properly
  window.addEventListener("CookiebotOnDialogDisplay", function() {
    // When Cookiebot is loaded, add a one-time event listener for CookiebotOnDecline
    function handleDecline() {
      // When CookiebotOnDecline is triggered, reload the page
      window.location.reload();
      // Remove the listener so it only triggers once
      window.removeEventListener("CookiebotOnDecline", handleDecline);
    }
    window.addEventListener("CookiebotOnDecline", handleDecline, { once: true });
  });
   

  //Set page scrolled height as a css variable
  document.addEventListener('DOMContentLoaded', () => {
    var r = document.querySelector(':root');

    // Read initial previous scroll value (defaults to current)
    let lastScrollPosition = window.scrollY;

    //On load
    r.style.setProperty('--scroll-direction', 'none');
    r.style.setProperty('--scrolled-Y', window.scrollY + 'px');

    //On scroll
    window.addEventListener("scroll", function(event) {
      let scrollDirection = window.scrollY > lastScrollPosition ? 'down' : 'up';

      r.style.setProperty('--scroll-direction', scrollDirection);
      r.style.setProperty('--scrolled-Y', window.scrollY + 'px');

      lastScrollPosition = window.scrollY;
    });
  })


  document.addEventListener('DOMContentLoaded', () => {
    //Set class on body, if header is sticky
    let header = document.querySelector("#shopify-section-header");
    let headerStyling = getComputedStyle(header);

    let positionStickyStylingValues = ['sticky', '-webkit-sticky'];
    
    if(headerStyling.position && positionStickyStylingValues.includes(headerStyling.position)) {
      document.querySelector('body').classList.add('header-is-sticky');
    }
  })


  //Landing page - Cookies required
  if(document.querySelector("body").classList.contains("theme-second_female") && document.querySelector(".cookies-required-container")) {
    // When cookies are updated, check if the box should be visible or not
    window.addEventListener('CookiebotOnConsentReady', function () {
      toggleCookiesRequiredContainer();
    })


    //On load, run an interval to make sure the correct data is there, so we can use it
    let cookiesRequiredFound;
    let maxRuns = 10;
    let runs = 0;
    let forceStopCookiesRequiredInterval = false;
    
    // Variable to store the interval ID
    let intervalId;
    
    // Function to be executed at each interval
    function cookiesRequiredIntervalFunction() {
      if(runs >= maxRuns || forceStopCookiesRequiredInterval) {
        clearInterval(intervalId); // Stop the interval
        return;
      } else {
        runs++;
      }
      
      //On load
      toggleCookiesRequiredContainer();

    }
    
    // Set the interval to run every 1000 milliseconds (1 second)
    intervalId = setInterval(cookiesRequiredIntervalFunction, 1000);

    

     function toggleCookiesRequiredContainer() { 
       let cookiesRequiredContainer = document.querySelector(".cookies-required-container");
       let klaviyoForm = document.querySelector(".PageContent > [class^=klaviyo-form]");
    
       if(!klaviyoForm) {
         return;
       }
    
       let klaviyoFormIsLoaded = klaviyoForm.querySelector(".klaviyo-form");
       
       if(!Cookiebot || !Cookiebot.consent) {
         return;
       }
    
        let isMarketingCookiesALlowed = Cookiebot.consent.marketing;
        let isStatisticsCookiesALlowed = Cookiebot.consent.statistics;

       if((isMarketingCookiesALlowed && isStatisticsCookiesALlowed) || klaviyoFormIsLoaded) {
         cookiesRequiredContainer.classList.add('hidden');
       } else {
         cookiesRequiredContainer.classList.remove('hidden');
       }
    
       forceStopCookiesRequiredInterval = true;
     }
  }

   //Add class to body element, whether dropdown menus are visible or not
  document.addEventListener('DOMContentLoaded', () => {
    initDropdownBodyClasses();
  }, false);

   if(document.querySelector("body").classList.contains("Previewing")) {
     initDropdownBodyClasses();
   }

   function initDropdownBodyClasses() {
    let body = document.querySelector("body");
    let dropdownMenus = document.querySelectorAll('.Header nav .HorizontalList__Item .DropdownMenu');
    
    if(!body || !dropdownMenus) {
      return;
    }

    dropdownMenus.forEach((dropdownMenu) => {
      let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          //If the visibility of the filter drawer has changed
          if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
            let dropdownIsHidden = dropdownMenu.getAttribute('aria-hidden') === 'true';
            
            if (dropdownIsHidden) {
              body.classList.remove('header-dropdown-menu-visible');
            } else {
              body.classList.add('header-dropdown-menu-visible');
            }
          }
        });
      });
      
      observer.observe(dropdownMenu, {
        attributes: true //configure it to listen to attribute changes
      });
    })
   }

  //Set countdown height as a css variable
  document.addEventListener('DOMContentLoaded', () => {
    var r = document.querySelector(':root');

    let countdown = document.querySelector(".shopify-section#shopify-section-countdown");

    if(!countdown) {
      r.style.setProperty('--countdown-height', '0px');
      return;
    }
    
    //On load
    r.style.setProperty('--countdown-height', countdown.offsetHeight + 'px');

    //On scroll
    window.addEventListener("scroll", function(event) {
      r.style.setProperty('--countdown-height', countdown.offsetHeight + 'px');
    });
  })

   //Update announcement bar height on resize
  document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('resize', function(event) {
      var r = document.querySelector(':root');

      let announcementBar = document.querySelector("#section-announcement");
  
      if(!announcementBar) {
        r.style.setProperty('--announcement-bar-height', '0px');
        return;
      }
      
      r.style.setProperty('--announcement-bar-height', announcementBar.offsetHeight + 'px');
    }, true);
    
  })

  //Add mega menu push links to mobile menu
  document.addEventListener('DOMContentLoaded', () => {
    let megaMenuLinksToAddToMobileMenu = document.querySelectorAll(".MegaMenu__PushLink[data-add-link-to-mobile-menu]");

    megaMenuLinksToAddToMobileMenu.forEach((megaMenuLinkToAddToMobileMenu) => {
      let mobileMenuIndexToAddTo = megaMenuLinkToAddToMobileMenu.getAttribute("data-add-link-to-mobile-menu");

      if(mobileMenuIndexToAddTo === undefined) {
        return;
      }

      let mobileMenuItemToAddTo = document.querySelector("#sidebar-menu .Drawer__Container > .SidebarMenu__Nav--primary > .Collapsible[data-link-index='"+ mobileMenuIndexToAddTo +"']");

      if(!mobileMenuItemToAddTo) {
        return;
      }
      
      let href = megaMenuLinkToAddToMobileMenu.href;
      let text = megaMenuLinkToAddToMobileMenu.getAttribute("data-title");
      
      let collapsibleInner = false;

      let children = Array.from(mobileMenuItemToAddTo.children);
      
      children.forEach((child) => {
        if(child.classList.contains("Collapsible__Inner")) {
          collapsibleInner = child;
        }
      })

      if(!collapsibleInner) {
        let mobileMenuItemToAddToText = mobileMenuItemToAddTo.querySelector(".Collapsible__Button").text;
        
        mobileMenuItemToAddTo.innerHTML = '<button class="Collapsible__Button Heading u-h6" data-action="toggle-collapsible" aria-expanded="false">'+ mobileMenuItemToAddToText 
          +'<span class="Collapsible__Plus"></span></button><div class="Collapsible__Inner"><div class="Collapsible__Content"></div></div>';

        collapsibleInner = mobileMenuItemToAddTo.querySelector(".Collapsible__Inner");
      }

      if(collapsibleInner) {        
        let collapsibleInnerContent = collapsibleInner.querySelector(".Collapsible__Content");

        if(!collapsibleInnerContent) {
          return;
        }
        
        collapsibleInnerContent.innerHTML += '<div class="Collapsible"><a href="'+ href +'" class="Collapsible__Button Heading Text--subdued Link Link--primary u-h7">'+ text +'</a></div>';
      }
    })
  })

  document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('resize', () => {
        let screenSize = window.innerWidth;
    
        setTimeout(() => {
            let newScreenSize = window.innerWidth;
    
            if(screenSize === newScreenSize) {
                window.dispatchEvent(new CustomEvent('resize-done'));
            }
        }, 500);
    });
    
   //Try to prevent weird sizes on sliders, when resizing
    window.addEventListener('resize-done', function(event) {
      let flickitySliders = document.querySelectorAll('.Slideshow__Carousel.flickity-enabled');
      
      flickitySliders.forEach((flickitySlider) => {
        let flkty = Flickity(flickitySlider);
        
        if(flkty) {
          let screenSize = window.innerWidth;

          //Run instantly
          flkty.resize();
          
          //... And wait a little to run it, to make sure animation is done
          setTimeout(() => {
            if(screenSize === window.innerWidth) {
              flkty.resize();
            }
          }, 1500)
        }
      })
    }, true);
  })

   
})();
   










